import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR DETAIL ---------------- */
export const fetchValuatorDetail = createAsyncThunk(
	"valuator/fetchDetail",
	async (valuatorCode, { rejectWithValue }) => {
		try {
			const response = await api.get(`/v1/Valuator/${valuatorCode}/detailed`);

			return response.data.data;
		} catch (err) {
			return rejectWithValue(err.response?.data);
		}
	},
);
const initialState = {
	profile: null,
	loading: false,
	error: null,
};
const valuatorSlice = createSlice({
	name: "valuatorDetail",
	initialState,
	reducers: {
		clearValuator: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchValuatorDetail.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchValuatorDetail.fulfilled, (state, action) => {
				state.loading = false;
				state.profile = action.payload;
			})
			.addCase(fetchValuatorDetail.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearValuator } = valuatorSlice.actions;
export default valuatorSlice.reducer;
